import { render, staticRenderFns } from "./CafeEdit.vue?vue&type=template&id=8810cdd2&scoped=true"
import script from "./CafeEdit.vue?vue&type=script&lang=js"
export * from "./CafeEdit.vue?vue&type=script&lang=js"
import style0 from "./CafeEdit.vue?vue&type=style&index=0&id=8810cdd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8810cdd2",
  null
  
)

export default component.exports